import React from 'react'
import { Flex } from '@leverege/ui-elements'

export default function FormRow( props ) {
  const { children, width = 300, ...rest } = props

  return (
    <Flex
      style={{
        width
      }}
      {...rest}>
      {children}
    </Flex>
  )
}
